import HtmlParser from 'react-html-parser';

import './styles.scss';

function GeneralTile({ data, width }) {
  const text = (text) => {
    return text.toString().replace(/(\S+)-(\S+)/g, '$1&#8209;$2');
  };

  switch (data.type) {
    case 1:
      return (
        <div
          className="GeneralTile-1-container"
          style={{ width: `${width}` }}
        >
          <div className="GeneralTile-1-wrapper">
            <div className="GeneralTile-1-subcontainer">
              <img
                className="GeneralTile-1-image"
                src={data.image}
                alt="img"
              />
              <p className="GeneralTile-1-title">
                {HtmlParser(text(data.title))}
              </p>
            </div>
            <p className="GeneralTile-1-description">
              {data.description}
            </p>
          </div>
        </div>
      );
    case 2:
      return (
        <div
          className="GeneralTile-2-container"
          style={{ width: `${width}` }}
        >
          <div className="GeneralTile-2-wrapper">
            <div className="GeneralTile-2-subcontainer">
              <img
                className="GeneralTile-2-image"
                src={data.image}
                alt="img"
              />
              <p className="GeneralTile-2-title">
                {HtmlParser(text(data.title))}
              </p>
            </div>
            <p className="GeneralTile-2-description">
              {data.description}
            </p>
          </div>
        </div>
      );
    case 3:
      return (
        <div
          className="GeneralTile-3-container"
          style={{ width: `${width}` }}
        >
          <div className="GeneralTile-3-wrapper">
            <div className="GeneralTile-3-subcontainer">
              <img
                className="GeneralTile-3-image"
                src={data.image}
                alt="img"
              />
              <p className="GeneralTile-3-title">
                {HtmlParser(text(data.title))}
              </p>
            </div>
            <p className="GeneralTile-3-description">
              {data.description}
            </p>
          </div>
        </div>
      );
    case 4:
      return (
        <div
          className="GeneralTile-4-container"
          style={{ width: `${width}` }}
        >
          <div className="GeneralTile-4-wrapper">
            <div className="GeneralTile-4-content">
              <img
                className="GeneralTile-4-image"
                src={data.image}
                alt="img"
              />
              <div className="GeneralTile-4-subcontainer">
                <p className="GeneralTile-4-title">
                  {HtmlParser(text(data.title))}
                </p>
                <p className="GeneralTile-4-description">
                  {data.description}
                </p>
              </div>
            </div>
          </div>
        </div>
      );
    default:
      return null;
  }
}

export default GeneralTile;
